
//action types
export const GET_DASHBOARD_API_CALLS = 'GET_DASHBOARD_API_CALLS';
export const GET_API_VALIDITY_USER = "GET_API_VALIDITY_USER";


export function getDashboardApiCall(data, callback) {
    return {
        type: GET_DASHBOARD_API_CALLS,
        payload: { data, callback },
    };
}

export function getApiValidityUserCall(data, callback) {
    return {
        type: GET_API_VALIDITY_USER,
        payload: { data, callback },
    };
}
